(() => {
  const listing = /^\/(collections|search)(\/|$)/.test(location.pathname) && !location.pathname.includes('/products/');
  if (!listing) return;
  const theme = document.currentScript?.dataset.themeId || 'default';
  const prefix = `jd-browse-return:v2:${theme}:`;
  const key = () => prefix + location.pathname + location.search;
  const path = (href) => new URL(href, location.origin).pathname;
  let restoring = false;
  let lastSaved = null;
  try { history.scrollRestoration = 'manual'; } catch (_) {}
  const save = (link) => {
    const grid = document.querySelector('custom-pagination');
    const results = grid?.querySelector('#filter-results');
    if (!results) return;
    const item = link?.closest('.js-pagination-result');
    const saved = {
      savedAt: Date.now(), html: results.innerHTML,
      count: results.querySelectorAll('.js-pagination-result').length,
      href: item ? path(link.href) : null,
      offset: item?.getBoundingClientRect().top, y: window.scrollY,
      width: window.innerWidth
    };
    try {
      sessionStorage.setItem(key(), JSON.stringify(saved));
      lastSaved = saved;
    } catch (_) {
      saved.html = null;
      try { sessionStorage.setItem(key(), JSON.stringify(saved)); lastSaved = saved; } catch (_) {}
    }
  };
  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || url.pathname === location.pathname || link.closest('.js-pagination,facet-filters')) return;
    save(link);
  }, true);
  window.addEventListener('pagehide', () => {
    if (!restoring && !lastSaved) save(null);
  });
  const restore = async (event) => {
    if (restoring) return;
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!event?.persisted && navigation?.type !== 'back_forward') return;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(key()) || 'null'); } catch (_) { return; }
    if (!saved || Date.now() - saved.savedAt > 15 * 60 * 1000) return;
    const grid = document.querySelector('custom-pagination');
    const results = grid?.querySelector('#filter-results');
    if (!results) return;
    restoring = true;
    lastSaved = null;
    grid.dataset.pauseInfiniteScroll = 'true';
    grid.controller?.abort();
    const root = document.documentElement;
    const oldAnchor = root.style.overflowAnchor;
    const oldBehavior = root.style.scrollBehavior;
    root.style.overflowAnchor = 'none';
    root.style.scrollBehavior = 'auto';
    let cancelled = false;
    let frame;
    let observer;
    let timer;
    const finish = () => {
      if (!restoring) return;
      cancelled = true;
      cancelAnimationFrame(frame);
      clearTimeout(timer);
      observer?.disconnect();
      for (const name of ['wheel', 'touchstart', 'keydown', 'pointerdown']) window.removeEventListener(name, stop);
      root.style.overflowAnchor = oldAnchor;
      root.style.scrollBehavior = oldBehavior;
      grid.dataset.pauseInfiniteScroll = 'false';
      restoring = false;
    };
    const stop = () => finish();
    for (const name of ['wheel', 'touchstart', 'keydown', 'pointerdown']) window.addEventListener(name, stop, { passive: true });
    try {
      if (results.querySelectorAll('.js-pagination-result').length < saved.count) {
        if (saved.html) {
          results.innerHTML = saved.html;
          grid.reload?.();
        } else {
          grid.dataset.pauseInfiniteScroll = 'false';
          while (!cancelled && results.querySelectorAll('.js-pagination-result').length < saved.count && grid.querySelector('.js-pagination-load-more')) {
            const count = results.querySelectorAll('.js-pagination-result').length;
            await grid.loadMore?.();
            if (results.querySelectorAll('.js-pagination-result').length <= count) break;
          }
          grid.dataset.pauseInfiniteScroll = 'true';
        }
      }
      const position = () => {
        if (cancelled) return;
        const link = saved.href && [...results.querySelectorAll('a[href]')].find((a) => path(a.href) === saved.href);
        const item = link?.closest('.js-pagination-result');
        const offset = Math.min(saved.offset || 0, window.innerHeight * 0.6);
        const y = item ? window.scrollY + item.getBoundingClientRect().top - offset : saved.y;
        if (Math.abs(window.scrollY - y) > 1) window.scrollTo({ top: Math.max(0, y), behavior: 'instant' });
      };
      await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      position();
      observer = new ResizeObserver(position);
      observer.observe(results);
      const until = performance.now() + 3500;
      const settle = () => {
        if (cancelled) return;
        position();
        if (performance.now() < until) frame = requestAnimationFrame(settle);
        else finish();
      };
      frame = requestAnimationFrame(settle);
      timer = setTimeout(finish, 4000);
    } catch (_) { finish(); }
  };
  window.addEventListener('pageshow', restore);
})();
